export default __webpack_public_path__ + "static/media/maximum_bet_100$.60ebd51f.mp3";